import { Grid } from '@material-ui/core';
import { AddRiskFormField } from 'modules';
import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';

// A component that represents an array of key/value pairs
const ValueSet = ({ field, child = null, prefix, formProps }) => {
  const [optionsToPopulate, setOptionsToPopulate] = useState([]);

  const mirrorValues = field.mirror ? useWatch({ name: `${prefix}${field.mirror}`, control: formProps?.control }) : null;
  useEffect(() => {
    if (mirrorValues) {
      const options = field.options?.filter((option) => mirrorValues?.includes(option?.value));
      const selectedOptionValues = options?.flatMap((option) => option?.value);

      const valueSet = formProps.getValues(`${prefix}${field.name}`);
      optionsToPopulate?.forEach((option) => {
        const index = valueSet?.findIndex((item) => item.key === option.value) ?? 0;
        if (!selectedOptionValues?.includes(option?.value)) {
          formProps.setValue(`${prefix}${field.name}[${index}]`, {});
        }
      });
      setOptionsToPopulate(options);
    } else if (!field.mirror) {
      const prePopulatedFields = field.options?.filter((option) => option.prePopulate);
      setOptionsToPopulate(prePopulatedFields);
    }
  }, [mirrorValues]);

  useEffect(() => {
    const valueSet = formProps.getValues(`${prefix}${field.name}`);
    optionsToPopulate?.forEach((option, index) => {
      const valuesetIndex = valueSet?.findIndex((item) => item.key === option.value) ?? 0;
      if (valuesetIndex !== -1) {
        formProps.setValue(`${prefix}${field.name}[${valuesetIndex}].key`, valueSet[valuesetIndex].key);
        formProps.setValue(`${prefix}${field.name}[${valuesetIndex}].value`, valueSet[valuesetIndex].value);
      } else {
        const newValueSet = formProps.getValues(`${prefix}${field.name}`);
        const newIndex = newValueSet?.some((option) => option.key == null)
          ? newValueSet?.findIndex((option) => option.key == null)
          : newValueSet?.length;
        formProps.setValue(`${prefix}${field.name}[${newIndex}].key`, option.value);
      }
    });
  }, [optionsToPopulate]);

  const valueType = field.arrayItemDef.find((def) => def.name === 'value')?.type;

  const currentValues = formProps.getValues(`${prefix}${field.name}`);
  return (
    <>
      {optionsToPopulate?.map((option) => {
        const index = currentValues?.findIndex((item) => item.key === option.value) ?? 0;
        let valuesetIndex = index;
        if (index === -1) {
          if (currentValues?.some((option) => option.key == null)) valuesetIndex = currentValues?.findIndex((option) => option.key == null);
          else valuesetIndex = currentValues?.length;
        }
        return (
          <Grid item xs={6} sm={6} md={4} key={`visible-${option.value}`}>
            <AddRiskFormField
              key={option.value}
              field={{
                type: valueType,
                label: option.label,
                child,
                name: `${prefix}${field.name}[${valuesetIndex}].value`,
              }}
              formProps={formProps}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default ValueSet;
